import { useState, useEffect } from 'react';

const TOUR_COMPLETED_KEY = 'dermowize_tour_completed';

export const useTour = () => {
  const [isTourVisible, setIsTourVisible] = useState(false);
  const [hasCompletedTour, setHasCompletedTour] = useState(false);

  // Check if tour has been completed on mount
  useEffect(() => {
    const tourCompleted = localStorage.getItem(TOUR_COMPLETED_KEY);
    console.log('Tour completed from localStorage:', tourCompleted);
    setHasCompletedTour(tourCompleted === 'true');
  }, []);

  // Start the tour
  const startTour = () => {
    console.log('startTour called, setting isTourVisible to true');
    console.log('Current isTourVisible:', isTourVisible);
    setIsTourVisible(true);
    console.log('isTourVisible set to true');
  };

  // Complete the tour
  const completeTour = () => {
    setIsTourVisible(false);
    setHasCompletedTour(true);
    localStorage.setItem(TOUR_COMPLETED_KEY, 'true');
  };

  // Reset tour (for testing or user preference)
  const resetTour = () => {
    setIsTourVisible(false);
    setHasCompletedTour(false);
    localStorage.removeItem(TOUR_COMPLETED_KEY);
    localStorage.removeItem('dermowize_tour_auto_started');
  };

  // Auto-start tour for new users (only once)
  const autoStartTour = () => {
    console.log('autoStartTour called, hasCompletedTour:', hasCompletedTour);
    const hasAutoStarted = localStorage.getItem('dermowize_tour_auto_started');
    
    if (!hasCompletedTour && !hasAutoStarted) {
      // Mark as auto-started so it won't auto-start again
      localStorage.setItem('dermowize_tour_auto_started', 'true');
      
      // Delay to ensure page is fully loaded
      setTimeout(() => {
        console.log('Starting tour after delay...');
        startTour();
      }, 1000);
    }
  };

  return {
    isTourVisible,
    hasCompletedTour,
    startTour,
    completeTour,
    resetTour,
    autoStartTour
  };
};
